import React from 'react';
import { Footer } from './components/Footer';
import { CommentPage } from './page/CommentPage';

export const App = () => {
  return (
    <>
      <CommentPage />
      <Footer />
    </>
  );
};
